export const CLASS_NAMES = {
  container: 'flex flex-1 flex-col',
  titleWrapper: 'flex w-full flex-row items-center mt-2',
  title:
    'text-style-f-em text-netural-800 border-l border-neutral-300 ml-4 pl-4 mr-10',
};

export const TITLE = 'Finance application';

export const STEPS_CLASS_NAMES = {
  container:
    'flex flex flex-row justify-between items-center mt-2 mb-4 mr-4 md:flex-col md:items-start',
};
